import CreateRole from './CreateRole'

export default CreateRole
